/**
 * Store: Product
 * -----------------------------------------------------------------------------
 * Root store for any product variant data
 *
 */
 export default {
  namespaced: true,

  state: () => ({
    size: null,
    sizeFamily: null,
    colourFamily: null,
    product: null,
    productsByTag: null,
    productsByTagState: 'loading',
    quickAddProductsByTag: null,
    variant: false,
    test: new Map(),
  }),

  getters: {

    /**
     * Get store products by namespace.
     * @param {String} namespace - products namespace.
     * @returns {Number}
     */
     getProductsByNamespace: (state) => (namespace) => {
      if (namespace === 'quickadd') {
        return state.quickAddProductsByTag
      }

      return state.productsByTag
    },
  },

  mutations: {

    /**
     * Set product size category.
     * @param {String} size - Size of current product, standard or plus.
     */
    SET_SIZE(state, size) {
      state.size = size
    },

    /**
     * Set product.
     * @param {Object} product - Current PDP product.
     */
     SET_PRODUCT(state, product) {
      state.product = product
    },

    /**
     * Set variant.
     * @param {Object} variant - Currently selected variant.
     */
     SET_VARIANT(state, variant) {
      state.variant = variant
    },

    /**
     * Set colour family.
     * @param {String} family - String value of the colour family for current product.
     */
     SET_COLOUR_FAMILY(state, family) {
      state.colourFamily = family
    },

    /**
     * Set size family.
     * @param {String} family - String value of the size family for current product.
     */
     SET_SIZE_FAMILY(state, family) {
      state.sizeFamily = family
    },

    /**
     * Sets products by tag array.
     * @param {Array} products - Array of product objects.
     */
     SET_PRODUCTS_BY_TAG(state, products) {
      state.productsByTag = products
    },

    /**
     * Sets quick add products by tag array.
     * @param {Array} products - Array of product objects.
     */
     SET_QUICK_ADD_PRODUCTS_BY_TAG(state, products) {
      state.quickAddProductsByTag = products
    },

    /**
     * Set loading state fo products by tag query.
     * @param {String} status - Loading status.
     */
     SET_PRODUCTS_BY_TAG_STATE(state, status) {
      state.productsByTagState = status
    },

    SET_PRODUCT_TEST(state, status) {
      state.test.set('test', 'Data')
    },
  },

  actions: {

    /**
     * Sets the current product size category to state.
     * @param {String} size - The size category of the current product.
     */
    setCurrentSize({ commit }, size) {
      commit('SET_SIZE', size)
    },

    /**
     * Set colour family.
     * @param {String} family - String value of the colour family for current product.
     */
     setColourFamily({ commit }, family) {
      commit('SET_COLOUR_FAMILY', family)
    },

    /**
     * Set size family.
     * @param {String} family - String value of the size family for current product.
     */
     setSizeFamily({ commit }, family) {
      commit('SET_SIZE_FAMILY', family)
    },

    /**
     * Sets products by tag array.
     * @param {Array} products - Array of product objects.
     */
     setProductsByTag({ commit }, products) {
      commit('SET_PRODUCTS_BY_TAG', products)
    },

    /**
     * Sets quick add products by tag array.
     * @param {Array} products - Array of product objects.
     */
     setQuickAddProductsByTag({ commit }, products) {
      commit('SET_QUICK_ADD_PRODUCTS_BY_TAG', products)
    },

    /**
     * Set loading state fo products by tag query.
     * @param {String} status - Loading status.
     */
     setProductsByTagState({ commit }, status) {
      commit('SET_PRODUCTS_BY_TAG_STATE', status)
    },

    /**
     * Set product.
     * @param {Object} product - Current PDP product.
     */
     setProduct({ commit }, product) {
      commit('SET_PRODUCT', product)
    },

     /**
      * Set variant.
      * @param {Object} variant - Currently selected variant.
      */
     setVariant({ commit }, variant) {
      commit('SET_VARIANT', variant)
    },
  },
}
